export const TRADE_AT_TIME_FORMAT =
  window.env.TRADE_AT_TIME_FORMAT || 'h:mm:ss A';
export const GRPC_ENDPOINT = window.env.GRPC_ENDPOINT;
export const ENABLE_WEBSOCKET = window.env.ENABLE_WEBSOCKET;
export const REQUIRED_INVESTMENT_OBJECTIVE_CODE =
  window.env.REQUIRED_INVESTMENT_OBJECTIVE_CODE;
export const BANK_REVERSE_STATUS = window.env.BANK_REVERSE_STATUS;
